import { GET_COMPANY } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import type { ICompanyMetrics } from "@models";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export const COMPANY_METRICS_KEY = "companyMetricsKey";

export const getCompanyMetricsKey = (companyUuid: string, basePath?: string) =>
  [COMPANY_METRICS_KEY, companyUuid, basePath] as const;

export const useCompanyMetrics = (
  companyUuid: string | undefined,
  basePath?: string,
  options?: Partial<
    UseQueryOptions<
      ICompanyMetrics,
      AxiosError,
      ICompanyMetrics,
      ReturnType<typeof getCompanyMetricsKey>
    >
  >,
) => {
  return useQuery({
    queryKey: getCompanyMetricsKey(companyUuid ?? "", basePath),
    queryFn: async () => {
      const path = `${GET_COMPANY}/${companyUuid}/metrics`;
      const url = basePath ? `${basePath.replace(/\/$/, "")}${path}` : path;
      const data = await mutationFetch<ICompanyMetrics>({
        url,
        method: "GET",
      });
      return data;
    },
    enabled: !!companyUuid,
    ...options,
  });
};
